import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
} from "@mui/material";
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useMutation } from "react-query";
import { useSnackBars } from "../../contexts/Snackbar/SnackbarContext";
import { ButtonCustom } from "../Common.styled";
import {
  getStringToBoolean,
  getUrlPersonQr,
  getUrlPetQr,
} from "../../utils/functions";
import { typeObject } from "../../utils/constants";
import { X } from "@phosphor-icons/react";

export const BuscadorDePropietarios = ({ open, onClose, service, type }) => {
  const [value, setvalue] = useState();
  const [data, setdata] = useState([]);
  const { showErrorSnackbar } = useSnackBars();

  const { mutate, isLoading } = useMutation(() => service(value), {
    onSuccess: (res) => setdata(res),
    onError: (err) => {
      console.error(err);
      showErrorSnackbar(err?.response?.data?.body);
    },
  });

  const getUrlQr = (item) => {
    if (typeObject.persons === type) return getUrlPersonQr(item.id);
    if (typeObject.pets === type) return getUrlPetQr(item.id);
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose}>
        <DialogContent>
          <Box display={"flex"} justifyContent={"flex-end"}>
            <IconButton onClick={onClose}>
              <X size={30} />
            </IconButton>
          </Box>
          <TextField
            value={value}
            onChange={(e) => setvalue(e?.target?.value)}
          />
          <ButtonCustom
            onClick={() => {
              mutate();
              console.log(value);
            }}
          >
            Buscar
          </ButtonCustom>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Disponible</TableCell>
                  <TableCell>Usuario</TableCell>
                  <TableCell>Qr</TableCell>
                  <TableCell>Link</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <div>
                    <CircularProgress size={40} />
                  </div>
                ) : data?.length > 0 ? (
                  data?.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>
                        {getStringToBoolean(item?.created?.toString())
                          ? "No"
                          : "Si"}
                      </TableCell>
                      <TableCell>{item.email}</TableCell>
                      {/* <TableCell>
                    <ModalViewQr
                      paramQRBO={newQR}
                      name={item?.name}
                      position={"relative"}
                      url={getUrlPetQr(item.id)}
                      id={item?.id}
                    />
                  </TableCell> */}
                      <TableCell>
                        <Link to={getUrlQr(item)}>Ir a la pagina</Link>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <div>Sin resultados</div>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
};
